import { ReactNode } from 'react';
import { cn } from '@/lib/utils/cn';

interface EditorStepProps {
    number?: number | string;
    title: string;
    subtext?: string;
    subtextPlacement?: 'bottom' | 'right';
    error?: boolean;
    children?: ReactNode;
}

export const EditorStep = ({ number, title, subtext, error = false, children }: EditorStepProps) => {
    return (
        <section className='pb-15'>
            <div className='flex items-center gap-3 pb-5'>
                {number && (
                    <div className='bg-neutral-subtle text-caption-1-bold flex size-8 min-w-8 items-center justify-center rounded-full text-center'>
                        {number}
                    </div>
                )}
                <div className='text-base font-bold'>
                    <span className={cn(error && 'text-negative-active')}>{title}</span>
                    {subtext && <p className='text-caption-2-bold text-gray m-0 -mt-0.5'>{subtext}</p>}
                </div>
            </div>
            {children}
        </section>
    );
};
